import { useEffect, useMemo, useRef } from 'react'

import { IPartner } from '@/src/entities/partner/model'
import { IPreview } from '@/src/shared/model'

type scrollableItems = IPartner[] | IPreview[] | []

const useScrollable = (gallery: scrollableItems, isScrollable: boolean) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const scrollableGallery = useMemo(() => {
    if (!isScrollable) return gallery
    const loopTimes = 5
    return isScrollable ? Array(loopTimes).fill(gallery).flat() : gallery
  }, [gallery, isScrollable])

  useEffect(() => {
    if (!isScrollable) return
    const container = scrollContainerRef.current
    if (!container) return

    const handleScroll = () => {
      container.style.setProperty('--pause', 'paused')
    }

    container.addEventListener('scroll', handleScroll)
    return () => container.removeEventListener('scroll', handleScroll)
  }, [isScrollable])

  return { scrollContainerRef, scrollableGallery }
}

export default useScrollable
